import { api, getAuthHeaders, post } from "../../services.common";

export const getEventRegisteredUsersAdminAPI = async (payload) => {
    // console.log('payload: ', payload);
  let url = `${api}/admin/registered/users`;
  let authHeader = getAuthHeaders();
  return await post(url, { ...payload }, { ...authHeader });
};
